
export const OPEN_DISPATCH_CONFIG_MODAL = "open_dispatch_config_modal";
export const CLOSE_DISPATCH_CONFIG_MODAL = "close_dispatch_config_modal";
export const DISPATCH_CONFIG_CREATED = "dispatch_config_created"
export const DISPATCH_CONFIG_UPDATED = "dispatch_config_updated";
export const GET_DISPATCH_CONFIG_LIST = "get_dispatch_config_list";
export const DISPATCH_CONFIG_SET_ACTIVE = "dispatch_config_set_active";
export const DISPATCH_CONFIG_DELETE = "dispatch_config_delete"
